import axios from 'axios';
import * as CookieService from '../Cookie/CookieService';

const path = '/api/v1/attendance';

export function signIn(mobileNum) {
    return axios.post(path.concat('?mobileNum=' + mobileNum), mobileNum, CookieService.setHeaders());
}

export function signOut(mobileNum) {
    return axios.put(path.concat('?mobileNum=' + mobileNum), mobileNum, CookieService.setHeaders());
}

export function getAttendance() {
    return axios.get(path, CookieService.setHeaders());
}

export function getAttendanceListByAttendingDateAndName(pageVO, attendingDate, name) {
    let setParam = path.concat('/search?');
    if (attendingDate != undefined && attendingDate != null) {
        setParam += attendingDate + '/';
    } else {
        const KR_TIME_DIFF = 9 * 60 * 60 * 1000;
        const curr = new Date();
        const utc = curr.getTime() + (curr.getTimezoneOffset() * 60 * 1000);
        const today = new Date(utc + KR_TIME_DIFF);
        let searchDate = '' + today.getFullYear() + (today.getMonth() + 1) + today.getDate();
        setParam += 'date=' + searchDate;
    }
    if (name != undefined && name != null) {
        setParam += name + '?';
    }
    if (pageVO != null) {
        setParam += 'page=' + pageVO.page + '&size=' + pageVO.size + '&sort=' + pageVO.sortBy + ',' + pageVO.direction;
    }
    return axios.get(setParam, CookieService.setHeaders());
}


// WEBPACK FOOTER //
// ./src/services/Attendance/AttendanceService.js